import { onUnmounted } from '@vue/composition-api'

import { useToggle } from '@shared/use/use-toggle'

export const isDocumentVisible = (): boolean => {
  if (
    typeof document !== 'undefined' &&
    typeof document.visibilityState !== 'undefined'
  ) {
    return document.visibilityState !== 'hidden'
  }
  return true
}

export const useDocumentVisibility = () => {
  const [visible, toggle] = useToggle<boolean>(isDocumentVisible())

  const toggleVisible = () => {
    toggle(isDocumentVisible())
  }

  window.addEventListener('visibilitychange', toggleVisible)

  onUnmounted(() => {
    window.removeEventListener('visibilitychange', toggleVisible)
  })

  return visible
}
